import { createStore, applyMiddleware, compose } from 'redux';
import middlewares from './middlewares';
import reducers from './reducers';


const isDev = process.env.NODE_ENV !== 'production';
const isBrowser = typeof window !== 'undefined';

// development tools
const composeEnhancers =
  isBrowser && isDev && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

if (isDev) {
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}

const enhancers = [applyMiddleware(...middlewares)];

const configureStore = initialState => {
  const store = createStore(reducers, initialState, composeEnhancers(...enhancers));
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextReducer = require('./reducers').default;
      store.replaceReducer(nextReducer);
    });
  }

  return store;
};

export default configureStore;
